// Assembles a template into what the model receives (system + user) and what the user copies (one text).
import type { PromptInput, ReportTemplate } from './templates';

export interface AssembledPrompt {
  system: string;
  user: string;
  /** Single block for pasting into a chat product: system rules, a rule, then the user block. */
  full: string;
}

export function assemblePrompt(template: ReportTemplate, input: PromptInput): AssembledPrompt {
  const system = template.system(input);
  const user = template.user(input);
  return { system, user, full: `${system}\n\n——\n${user}` };
}
